export const RESERVED_DISCOVER_SEGMENTS = new Set([
  "events",
  "clubs",
  "api",
  "_next",
  "images",
  "favicon.ico",
  "sitemap",
  "sitemap.xml",
  "robots.txt",
]);

export const MIN_LOCATION_SLUG_LENGTH = 2;
export const MAX_LOCATION_SLUG_LENGTH = 100;
